import React from "react";
import SmallScreenFooter from "../../../../../components/smallscreen/footer";

type Props = {
  support: Object,
  whiteLabel: Boolean,
}

const InvoicePayFooter = (props:Props) => {
  const {support, whiteLabel} = props;
  return (
    <div className="mb-2">
      <SmallScreenFooter phone={support && support.phone} whiteLabel={whiteLabel}
                         email={support && support.email} children={null}/>
    </div>
  )
};

export default InvoicePayFooter
